import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { mediaQueries } from '@blazar-plugins/device'

const Wrapper = styled.div`
  position: relative;

  ul,
  ol {
    overflow-x: auto;
    list-style-type: none;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    ${({ listStyle }) => listStyle}
  }

  @media ${mediaQueries.large} {
    ul,
    ol {
      white-space: normal;
      ${({ listStyleLarge }) => listStyleLarge}
    }
    border-bottom: 0;
  }
`
const FadeRight = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 28px;
  pointer-events: none;
  background: linear-gradient(to left, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 100%);

  @media ${mediaQueries.large} {
    display: none;
  }
`

const FadeLeft = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  pointer-events: none;
  background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);

  @media ${mediaQueries.large} {
    display: none;
  }
`

export default class SideScroll extends React.PureComponent {
  constructor(props) {
    super(props)
    this.setULRef = (element) => {
      this.ulRef = element
    }
  }

  componentDidUpdate() {
    if (this.ulRef) {
      this.ulRef.scrollLeft = 0
    }
  }

  render() {
    const { children, ...other } = this.props

    return (
      <Wrapper {...other} ref={this.setULRef}>
        {children}
        <FadeRight />
        <FadeLeft />
      </Wrapper>
    )
  }
}

SideScroll.propTypes = {
  listStyle: PropTypes.string,
  listStyleLarge: PropTypes.string,
  children: PropTypes.node.isRequired,
}
